import { __awaiter, __generator } from "tslib";
import { fetchGet } from "../../common/http/fetch-get";
import { getCompatibilityGuideApiConfig } from "./config/actions";
import { buildAvailableStateQuery } from "./utilities/build-available-state-query";
export var fetchSolutionDetails = function (thirdPartyProducts, group, availableState) {
    if (availableState === void 0) { availableState = null; }
    return __awaiter(void 0, void 0, void 0, function () {
        var config, baseUrl, state, url;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    config = getCompatibilityGuideApiConfig();
                    baseUrl = config.baseUrl + "/api/product/" + group + "/details";
                    state = buildAvailableStateQuery(availableState);
                    url = baseUrl + "?thirdPartySearchKey=" + thirdPartyProducts.join(',') + "&marketLocale=" + config.marketLocale + state;
                    return [4 /*yield*/, fetchGet(url)];
                case 1: return [2 /*return*/, _a.sent()];
            }
        });
    });
};
